module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicole Peeler\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Nicole Peeler")]), _vm._v(" writes urban fantasy and is an associate professor at Seton Hill University, where she co-directs their MFA in Writing Popular Fiction. She is the author of the award-winning Jane True series and "), _c('I', [_vm._v("Jinn and Juice")]), _vm._v(", the first book in a series about a cursed jinni living in Pittsburgh. Nicole also lives in Pittsburgh, although she's neither cursed nor a jinni.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lTycFT/OEBPS/images/9780316076012_cover.jpg?1733067579626",
      "alt": "This image is the cover for the book Tracking the Tempest, Jane True Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tracking the Tempest, Jane True Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Valentine's Day is fast approaching, and Ryu -- Jane's bloodsucking boyfriend -- can't let a major holiday go by without getting all gratuitous. An overwhelming dose of boyfriend interference and a last-minute ticket to Boston later, and Jane's life is thrown off course."), _c('br'), _c('br'), _vm._v("Ryu's well-intentioned plans create mayhem, and Jane winds up embroiled in an investigation involving a spree of gruesome killings. All the evidence points towards another Halfling, much to Jane's surprise. . .")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Orbit\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0